import { Button, Stack, Text, Title } from "@mantine/core";
import { IconRefresh, IconWifi } from "@tabler/icons-react";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_public/503")({
  component: RouteComponent
});

const API_URL = import.meta.env.VITE_APP_API_URL || "http://localhost:3000";

async function isServiceOnline(): Promise<boolean> {
  try {
    await fetch(API_URL, { method: "HEAD", signal: AbortSignal.timeout(5000) });
    return true;
  } catch {
    return false;
  }
}

function RouteComponent() {
  const router = useRouter();

  useEffect(() => {
    isServiceOnline().then((online) => {
      if (online) router.history.back();
    });
  }, []);

  return (
    <Stack className="min-h-dvh bg-gray-50 p-4" justify="center" align="center">
      <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-2xl bg-white p-10 text-center shadow-md">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <IconWifi size={40} className="text-red-500" stroke={1.5} />
        </div>

        <div className="flex flex-col gap-2">
          <Title order={1} size={52} className="font-bold text-gray-800">
            503
          </Title>
          <Title order={2} size="h3" className="text-gray-700">
            Serviço Indisponível
          </Title>
          <Text c="dimmed" size="sm" className="mt-1">
            O serviço está temporariamente offline para manutenção ou por sobrecarga. Por favor, tente novamente em alguns instantes.
          </Text>
        </div>

        <Button leftSection={<IconRefresh size={16} />} variant="filled" color="red" radius="md" onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </div>
    </Stack>
  );
}
